import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./scrollbar.css";  // Add this line
import { Amplify } from "aws-amplify";
//import outputs from "../amplify_outputs.json";
import { UserProvider } from "./utils/hooks/userContext";
//import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";


/*const sessionStorageAdapter = {
  async setItem(key: string, value: string): Promise<void> {
    window.sessionStorage.setItem(key, value);
  },

  async getItem(key: string): Promise<string | null> {
    return window.sessionStorage.getItem(key);
  },

  async removeItem(key: string): Promise<void> {
    window.sessionStorage.removeItem(key);
  },

  async clear(): Promise<void> {
    window.sessionStorage.clear();
  },
};*/


//Amplify.configure(outputs);

const isLocalEnvironment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const redirectUrl = isLocalEnvironment
  ? "http://localhost:3000/"
  : "https://cfcrportal.com/";

console.log(redirectUrl);

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: "eu-west-1_VLUyq9koH",
      userPoolClientId: "3ftj3tmk0ogdcegdup9ag6irq8",
      identityPoolId: "eu-west-1:a0699b92-d3d9-4d00-b80c-453a77bef72c",
      loginWith: {
        oauth: {
          domain: "alj.auth.eu-west-1.amazoncognito.com",
          scopes: ["email", "openid"],
          redirectSignIn: [redirectUrl],
          redirectSignOut: [redirectUrl],
          responseType: "code",
        },
      },
    },
  },
});

//cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorageAdapter);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <UserProvider>
      <App />
    </UserProvider>
  </React.StrictMode>
);
